export const OM_CREATE_SUCCESS_TOAST_ID = 'operating-manual-create-success';
export const OM_SHARE_SUCCESS_TOAST_ID = 'operating-manual-share-success';
export const OM_SHARE_SUCCESS_VIEW_TOAST_ID =
  'operating-manual-share-success-view';
export const OM_REMOVE_SUCCESS_VIEW_TOAST_ID =
  'operating-manual-remove-success-view';

export const LEGACY_VIMEO_THUMBNAIL =
  'https://i.vimeocdn.com/video/1446869688-ebc55555ef4671d3217b51fa6fea2d6a1c1010568f048e57a22966e13c2c4338-d_640x360.jpg';

export const OPERATING_MANUAL_VIDEO_PLACEHOLDER = '../img/video_icon_demo.png';

export const VIDEO_EMBED_HOSTS = [
  'api.video',
  'player.vimeo',
  'youtube.com',
  'youtu.be',
];
